// extracted by mini-css-extract-plugin
export default {"cards":"_0a6js_b00a5UOe2ilEY","placeHolderShimmer":"L_FTR6SLiI9nUSkrJmPM"};